import { approvedUserStateType }      from "types";
import { submitApprovedUserFormType } from "actions/types";


const submitApprovedUser = (
    approvedUserState:      approvedUserStateType,
    error:                  string,
    setError:               (val: string) => void,
    submitApprovedUserForm: (payload: submitApprovedUserFormType) => void
) => {

    if ( approvedUserState.emailStr.length === 0 ) {
       setError('חובה להזין כתובת דוא״ל');
       return;
    }
    if ( approvedUserState.org_name.length === 0 ) {
      setError('חובה להזין שם מוסד');
      return;
   }
    if ( error.length ) {
      setError('')
    }
    submitApprovedUserForm(approvedUserState);
}

 export default submitApprovedUser

